import * as React from "react"
import { connect } from "react-redux"
import { Radio } from "antd"
import { setFilters } from "../../../../filters/actions"
import type { FiltersIdentifier, FiltersObject } from "../../../../filters/types"
import { getFilters } from "../../../../filters/selectors"
import { hasMPOSEnabled } from "../../../../auth/selectors"

type Props = {
    style?: Record<string, any>
    hasMPOSEnabled: boolean
    filters: FiltersObject
    identifier: FiltersIdentifier
    setFilters: (identifier: FiltersIdentifier, attributes: any) => void
}
const defaultStyles = {
    width: "100%",
}

class FigureVsMakeItButterOrdersFilter extends React.PureComponent<Props> {
    setStatusFilter = val => {
        this.props.setFilters(this.props.identifier, {
            source: val.target.value,
        })
    }

    render() {
        return (
            <div className="status-filter-component">
                <Radio.Group
                    value={this.props.filters.source}
                    onChange={val => this.setStatusFilter(val)}
                    style={{ ...defaultStyles, ...this.props.style }}>
                    <Radio.Button value="all">All</Radio.Button>
                    <Radio.Button value="pos">POS</Radio.Button>
                    {this.props.hasMPOSEnabled ? <Radio.Button value="mpos">mPOS</Radio.Button> : null}
                    <Radio.Button value="kiosk">Kiosk</Radio.Button>
                    <Radio.Button id="figureVsMibFilterMiB" value="mib">
                        Online Ordering
                    </Radio.Button>
                </Radio.Group>
                <style jsx={true} global={true}>
                    {`
                        .status-filter-component .ant-radio-button-wrapper-checked {
                            background-color: var(--primary-color);
                            color: #fff;
                        }
                    `}
                </style>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    filters: getFilters(state, props.identifier),
    hasMPOSEnabled: hasMPOSEnabled(state),
})

const mapDispatchToProps = {
    setFilters: setFilters,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(FigureVsMakeItButterOrdersFilter)
